import React from 'react';
import classNames from 'classnames';

export default class ScrollTopButton extends React.Component {

  constructor(){
    super();
    this.state = {
      visible: false,
      threshold: 350,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', () => this.handleScroll());
  }

  handleScroll() {
    const top = window.scrollY;
    const { threshold, visible } = this.state;

    const shouldShow = threshold < top;

    if((shouldShow && visible) || (!shouldShow && !visible)){
      return;
    }

    this.setState({
      visible: threshold < top
    });

  };

  render(){
    const { visible } = this.state;
    return(
      <a href="#" className={classNames(['scroll-top', { 'show' : visible }])} />
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/scroll-top/index.js